import { Flex, Text } from '@shared/components';

import type { TimePostponementSessionState } from '../../types';
import { formatSessionStartToEndTime } from '../../utils';

export interface TimePostponementSessionTimeProps {
  sessions: TimePostponementSessionState[];
  errorMessage?: string;
}

export default function TimePostponementSessionTime(
  props: Readonly<TimePostponementSessionTimeProps>,
) {
  const { sessions, errorMessage } = props;

  const isMultipleSessions = sessions.length > 1;

  return (
    <Flex
      sx={(theme) => ({
        flexDirection: 'column',
        borderRadius: theme.shape.rounded(2),
        px: theme.spacing(4),
        py: theme.spacing(3.5),
        backgroundColor: errorMessage ? theme.palette.error.lighter : theme.palette.warning.lighter,
        color: theme.palette.warning.darker,
        gap: theme.spacing(1),
      })}
    >
      <Text>เวลาสอบใหม่</Text>
      {sessions.map((session) => {
        if (session.isStarted) {
          return null;
        }

        return (
          <Flex
            sx={(theme) => ({
              alignItems: 'center',
              gap: theme.spacing(2),
            })}
            key={session.round}
          >
            {isMultipleSessions ? (
              <Text variant='body1Semibold'>ช่วงที่ {session.round}:</Text>
            ) : null}
            <Text variant='body1Semibold'>
              {formatSessionStartToEndTime(session.start, session.end)}
            </Text>
          </Flex>
        );
      })}

      {errorMessage ? <Text variant='body2'>{errorMessage}</Text> : null}
    </Flex>
  );
}
